import React, { Component } from "react";
import * as styles from "./authentication.styles";
import { css } from "react-emotion";
import { withRedux, displayError } from "helpers";
import { Button } from "appStyles";

const container = css`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0.5em;
  width: 100%;
  height: 85%;
`;
const wrapper = css`
  margin: 0 auto;
  float: none;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  @media only screen and (min-width: 768px) {
    width: 500px;
  }
  width: 100%;
`;
const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const col1 = css`
  @media only screen and (min-width: 768px) {
    text-align: center;
  }
  @media only screen and (min-width: 300px) {
    text-align: center;
  }
`;
const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 10px;
  margin-bottom: 35px;
`;
const form = css`
  background: white;
  padding: 1em;
  /* width: 35%; */
`;

class ForgotPassword extends Component {
  state = {
    email: "",
    forgotPasswordSent: false,
  };

  submit = (e) => {
    e.preventDefault();
    const { email } = this.state;
    if (!email) return displayError("Invalid Email.");
    this.props.actions.forgotPassword(this.state.email).then((res) => {
      this.setState({ forgotPasswordSent: true });
    });
  };

  getResetToken = () => {
    return new URLSearchParams(this.props.location.search).get("token");
  };

  update = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  renderFormContent = () => {
    const { forgotPasswordSent, email } = this.state;

    if (forgotPasswordSent) {
      return (
        <p className={styles.message}>
          A password reset email has been sent to {email}.
        </p>
      );
    } else {
      return (
        <React.Fragment>
          <p className={styles.message}>
            Enter your email address and we’ll send you a link to set your
            password.
          </p>
          <input
            type="text"
            className={styles.inputStyle}
            placeholder="Email"
            name="email"
            onChange={this.update}
            value={email}
          />
          <Button onClick={this.submit}>Submit</Button>
        </React.Fragment>
      );
    }
  };

  render() {
    return (
      <div className={wrapper}>
        <div className={row}>
          <div className={col + " " + col1}>
            <form className={form} onSubmit={this.submit}>
              <h1>Account Recovery</h1>
              {this.renderFormContent()}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRedux(ForgotPassword);
